import { Button, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { FEATURE_FLAGS } from "../../utils/constants";
import { getFeatureFlag } from "../../utils/io";
import { useHubMeasureRealtime } from "../hooks";
import TrustedDeviceIcon from "../icons/TrustedDeviceIcon";
import MeasureList from "../MeasureList";
import TrustedDevice from "./TrustedDevice";

function RecentMeasures(props) {
  const [isOpen, setIsOpen] = useState(false);
  const {
    loading,
    measures,
    setMeasures,
    measureSelection,
    setMeasureSelection,
    onChangeBindings,
    autoRefreshMeasure,
    setAutoRefreshMeasure,
    useTrustedDevices,
    hub,
    paginationModel,
    setPaginationModel,
    totalCount,
  } = props;

  const { latestHubMeasure } = useHubMeasureRealtime(hub?.hub_id);

  useEffect(() => {
    if (!latestHubMeasure) return;
    if (!latestHubMeasure.full_measure?.id) return;

    setMeasures((prev) => [latestHubMeasure.full_measure, ...prev]);
  }, [latestHubMeasure, setMeasures]);

  const handleTrustedDevice = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Stack>
      <Stack
        sx={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2>Recent Device Measures</h2>
        {getFeatureFlag(FEATURE_FLAGS.TRUSTED_DEVICES) && useTrustedDevices && (
          <Button
            variant="contained"
            sx={{ height: "fix-content", gap: 1 }}
            onClick={handleTrustedDevice}
          >
            <TrustedDeviceIcon />
            <Typography>Trusted Devices</Typography>
          </Button>
        )}
      </Stack>
      <TrustedDevice
        isHubConnected={!hub?.connected}
        isOpen={isOpen}
        handleTrustedDevice={handleTrustedDevice}
      />
      <MeasureList
        checkbox
        loading={loading}
        onSelectionChanged={setMeasureSelection}
        selectedMeasures={measureSelection}
        rowsPerPageOptions={[5, 10, 20, 50]}
        rowCount={totalCount}
        searchResults={measures}
        rows={measures}
        hideColumns={["hub_id", "device_make", "device_model"]}
        onChangeBindings={onChangeBindings}
        setAutoRefreshMeasure={setAutoRefreshMeasure}
        autoRefreshMeasure={autoRefreshMeasure}
        setPaginationModel={setPaginationModel}
        paginationModel={paginationModel}
      />
    </Stack>
  );
}

export default RecentMeasures;

RecentMeasures.propTypes = {
  loading: PropTypes.bool.isRequired,
  measures: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setMeasures: PropTypes.func.isRequired,
  measureSelection: PropTypes.arrayOf(PropTypes.string).isRequired,
  setMeasureSelection: PropTypes.func.isRequired,
  onChangeBindings: PropTypes.func.isRequired,
  autoRefreshMeasure: PropTypes.bool.isRequired,
  setAutoRefreshMeasure: PropTypes.func.isRequired,
  useTrustedDevices: PropTypes.bool.isRequired,
  hub: PropTypes.shape({
    hub_id: PropTypes.string,
    connected: PropTypes.bool,
    hub_group: PropTypes.shape({
      use_trusted_devices: PropTypes.bool,
    }),
  }).isRequired,
  setPaginationModel: PropTypes.func.isRequired,
  paginationModel: PropTypes.shape({
    pageSize: PropTypes.number,
    page: PropTypes.number,
  }).isRequired,
  totalCount: PropTypes.number.isRequired,
};
